module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACIAAAAiCAYAAAA6RwvCAAABXElEQVR4Ae3XM2DdcRRH8dpcak+dutS23e5DbdtbtQ+1bVtrozFLtMW2b07wbN1fNHzm73nv7w4iAvPaQ8IesubPxq7oaDSEgK3Ygf7GQhg/A8F59DYSwvAtlENwAr1UQxjsgc+ohjQ5ip5qIYwNRRRqIXYOoYdKCEMTkAhxY79KCCNLkQnxYA+6RzSEge0ohnjxDVdxKUhXscVbxGVUQBR8cxfQGU9QDVHy2TmiP/6hBqLoo33EaMSjFqLsnSViEtIhhry2hExDFsSAWjyzhHTEeKQYCnnifLIORxxEUQ0eurt8B+IHREk17nm6mfXCdYiCKtz2dmftjlMQLypwG8dxMkjHsczXs6YbNnsJyccClZdnhrpgtYfnTi7maYRYYjphFnIhdrIxRyvE+QUpGdIkEzO1Qywx4xANQRqma4c4v79+Qx6mmgqxxAzGBcw3GWL/jOraqj/C20PqAASaGwsRM4yFAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/img/icon_keep.png
// module id = 1660
// module chunks = 1